import React from "react";
import { Link } from "react-router-dom";
import ErionPajaziti from "../assets/img/Erion_Pajaziti.png";
import EnsarAbdullahu from "../assets/img/Ensar_Abdullahu.png";
import AmirAzemi from "../assets/img/Amir_Azemi.png";
import EnsarPajaziti from "../assets/img/Ensar_Pajaziti.png";
import ElmedinaBucolli from "../assets/img/Elmedina_Bucolli.png";
import PetritSekiraqa from "../assets/img/Petrit_Sekiraqa.png";

function About() {
  const values = [
    {
      title: "Precise Storytelling",
      description:
        "We craft every frame with intention — clarity, emotion, and purpose drive our edits.",
    },
    {
      title: "Technical Excellence",
      description:
        "From cut to color, we uphold high-end standards across every production stage.",
    },
    {
      title: "Creative Partnership",
      description:
        "We collaborate closely with clients — building bold work through shared vision and trust.",
    },
  ];

  return (
    <div>
      <div className="text-center about-us-ballina">
        <h1>About us</h1>
        <p>
          We are a next-generation creative content and post-production studio.
          Our mission is simple, to craft world-class visual experiences that
          blend art, technology, and story. From emotionally-driven commercials
          to bold branded content, HoB Studio creates visuals that move
          audiences and elevate brands. We’re shaping the future of creative
          storytelling right here in the Balkans, with global ambition.
        </p>
      </div>

      <section className="team">
        <div className="text-center our_team_txt">
          <p>Our Team</p>
          <h2>
            Awesome team
            <br />
            members
          </h2>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="team_member">
                <img
                  src={ErionPajaziti}
                  alt="Erion Pajaziti"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="team_member">
                <img
                  src={EnsarAbdullahu}
                  alt="Ensar Abdullahu"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="team_member">
                <img src={AmirAzemi} alt="Amir Azemi" className="img-fluid" />
              </div>
            </div>
            <div className="col-md-3">
              <div className="team_member">
                <img
                  src={EnsarPajaziti}
                  alt="Ensar Pajaziti"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="team_member">
                <img
                  src={ElmedinaBucolli}
                  alt="Elmedina Bucolli"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="team_member">
                <img
                  src={PetritSekiraqa}
                  alt="Petrit Sekiraqa"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="text-center our_team_txt">
          <h2>Our Values</h2>
        </div>
        <div className="container">
          <div className="row g-4 justify-content-center align-items-stretch">
            {values.map((value, index) => (
              <div className="col-md-4 d-flex" key={index}>
                <div className={`card-wrapper card-${index + 1} w-100`}>
                  <div className="card-custom h-100 d-flex flex-column">
                    <div className="card-number mb-4">{index + 1}.</div>
                    <div className="card-text mt-auto">
                      <h5>
                        <b>{value.title}</b>
                      </h5>
                      <br />
                      {value.description}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section>
        <div className="text-center our_team_txt">
          <h2>
            Let's discuss and make <br />
            something <span>cool</span> together
          </h2>
          <Link to="/contact">
            Get in touch with us&nbsp;
            <i className="icon ion-android-arrow-forward"></i>
          </Link>
        </div>
        <div className="container">
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2934.2296735496097!2d21.148137074593187!3d42.656488116324844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13549f8de88e665f%3A0x4794b6535d983b98!2sHoB%20Studio!5e0!3m2!1sen!2s!4v1771846914263!5m2!1sen!2s"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
